<template>
  <v-sheet>
    <div class="accent-block mt-4 mb-4" v-if="afficheAideCreation">
      <p>
        <template v-if="creation">
          Veuillez saisir les informations relatives au déclarant.
        </template>
        <template v-else>
          Veuillez vérifier les informations pré-remplies et les compléter le cas-échéant.
        </template>
        <br />
        Celles-ci seront utilisées pour les échanges avec le tribunal compétent.
      </p>
    </div>
    <v-row>
      <v-col cols="12" md="4">
        <a-civilite-select
          dense
          filled
          label="Civilité"
          v-model="civilite"
          @input="notify('declarant.civilite')"
          :rules="[requiredRule(), serverRule('declarant.civilite')]"
          data-testid="civilite-declarant"
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          dense
          filled
          label="Nom"
          v-model="nom"
          @input="notify('declarant.nom')"
          :rules="[requiredRule(), serverRule('declarant.nom')]"
          data-testid="nom-declarant"
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          dense
          filled
          label="Prénom"
          v-model="prenom"
          @input="notify('declarant.prenom')"
          :rules="[requiredRule(), serverRule('declarant.prenom')]"
          data-testid="prenom-declarant"
        />
      </v-col>
      <v-col cols="12" md="6">
        <a-lien-combobox
          dense
          filled
          label="Lien avec l'association"
          clearable
          v-model="lien"
          @input="notify('declarant.lien')"
          :rules="[serverRule('declarant.lien')]"
          data-testid="lien-association-declarant"
        />
      </v-col>
      <v-col cols="12" md="6"> </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          dense
          filled
          label="Adresse"
          v-model="adresse"
          @input="notify('declarant.adresse')"
          :rules="[requiredRule(), serverRule('declarant.adresse')]"
          data-testid="adresse-declarant"
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          dense
          filled
          label="Complément adresse"
          v-model="complementAdresse"
          @input="notify('declarant.complementAdresse')"
          :rules="[serverRule('declarant.complementAdresse')]"
          data-testid="complement-adresse-declarant"
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          dense
          filled
          label="Code postal"
          v-model="codePostal"
          @input="notify('declarant.codePostal')"
          :rules="[requiredRule(), serverRule('declarant.codePostal')]"
          data-testid="code-postal-declarant"
        />
      </v-col>
      <v-col cols="12" md="6">
        <a-commune-combobox
          dense
          filled
          label="Commune"
          v-model.trim="ville"
          :codePostal="codePostal"
          @codePostal="codePostalChange"
          @input="notify('declarant.ville')"
          :rules="[requiredRule(), serverRule('declarant.ville')]"
          data-testid="commune-declarant"
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          class="hint-multiligne"
          dense
          filled
          label="Adresse courriel"
          v-model.trim="email"
          @input="notify('declarant.email')"
          :rules="[serverRule('declarant.email')]"
          hint="En saisissant votre courriel vous consentez à la notification électronique et acceptez d'être recontacté par voie électronique par le tribunal en cas de besoin lié à vos démarches en ligne."
          persistent-hint
          data-testid="mail-declarant"
        />
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
import makeValueData from "@/mixins/makeValueData";
import makeRules from "@/mixins/makeRules";
import ValueDataRules from "@/mixins/ValueDataRules";
import DepotMixin from "./DepotMixin";
import { mapGetters } from "vuex";

function mapTo(src, dest) {
  src = src || {};
  dest.nom = src.nom;
  dest.prenom = src.prenom;
  dest.lien = src.lien;
  dest.civilite = src.civilite;
  dest.adresse = src.adresse;
  dest.complementAdresse = src.complementAdresse;
  dest.codePostal = src.codePostal;
  dest.ville = src.ville;
  dest.notificationElectronique = src.notificationElectronique;
  dest.email = src.email;
}

export default {
  mixins: [DepotMixin, makeValueData(mapTo), makeRules(), ValueDataRules],
  props: {
    fonctionOrigine: {
      type: String,
      required: false,
    },
    creation: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      civiliteUtilisateur: "utilisateur/civilite",
      emailUtilisateur: "utilisateur/email",
      nomUtilisateur: "utilisateur/nom",
      prenomUtilisateur: "utilisateur/prenom",
      adresseUtilisateur: "utilisateur/adresse",
      complementAdresseUtilisateur: "utilisateur/complementAdresse",
      codePostalUtilisateur: "utilisateur/codePostal",
      villeUtilisateur: "utilisateur/ville",
    }),
  },
  watch: {
    email() {
      this.syncNotificationElectronique();
      this.changed();
    },
  },
  mounted() {
    this.syncStore();
  },
  methods: {
    syncNotificationElectronique() {
      this.notificationElectronique = "" !== (this.email || "").trim();
    },
    syncStore() {
      if (this.civiliteUtilisateur) this.civilite = this.civiliteUtilisateur;
      this.email = this.emailUtilisateur;
      this.syncNotificationElectronique();
      if (this.nomUtilisateur) this.nom = this.nomUtilisateur;
      if (this.prenomUtilisateur) this.prenom = this.prenomUtilisateur;
      if (this.adresseUtilisateur) this.adresse = this.adresseUtilisateur;
      if (this.complementAdresseUtilisateur)
        this.complementAdresse = this.complementAdresseUtilisateur;
      if (this.codePostalUtilisateur) this.codePostal = this.codePostalUtilisateur;
      if (this.villeUtilisateur) this.ville = this.villeUtilisateur;
      if (this.fonctionOrigine) this.lien = this.fonctionOrigine;
      this.changed();
    },

    codePostalChange(codePostaux) {
      const code = this.codePostal || "";
      if (codePostaux?.length) {
        const match = codePostaux.find(cp => cp.startsWith(code));
        if (match) {
          this.codePostal = match;
          this.changed();
        }
      }
    },
  },
};
</script>
